import { Field } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetBalanceFieldSet, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import WholePortionOvenDryingPeparationMultiTraySection from './WholePortionOvenDryingPeparationMultiTraySection';
import WholePortionOvenDryingPeparationSingleTraySection from './WholePortionOvenDryingPeparationSingleTraySection';

const WholePortionOvenDryingPreparationSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const singleTray = useSelector(
    pipe(createWorksheetSelector!('Masses.MassMeasurement.MeasuredConstantDryMass.DryingTrays'), (p) => p?.length < 2)
  );

  return (
    <NamePrefixModifier appendNamePrefix="Masses.MassMeasurement.MeasuredConstantDryMass">
      <ListFieldSection>
        <WorksheetBalanceFieldSet name="Equipment.Balance" />
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="oven" name="Equipment.Oven" />
      </ListFieldSection>
      {singleTray ? (
        <WholePortionOvenDryingPeparationSingleTraySection />
      ) : (
        <WholePortionOvenDryingPeparationMultiTraySection />
      )}
    </NamePrefixModifier>
  );
};
const WholePortionOvenDryingPreparationSection = withInjectedProps(WholePortionOvenDryingPreparationSectionBase);

export { WholePortionOvenDryingPreparationSection };
export default WholePortionOvenDryingPreparationSection;
